import React from 'react';
import { Navigate } from 'react-router-dom';
import { getUserRole } from '../utils/sessionStore';
import { getAllowedRolesForPath } from '../constants/routeAccess';
import { useAuth } from '../context/AuthContext';

export { getUserRole };

export function withRoleGuard(element, allowedRoles) {
  return <ProtectedRoute allowedRoles={allowedRoles} element={element} />;
}

export function guardRoute(element, path) {
  const allowedRoles = getAllowedRolesForPath(path);
  if (!allowedRoles) {
    return <ProtectedRoute allowedRoles={[]} element={element} />;
  }
  return <ProtectedRoute allowedRoles={allowedRoles} element={element} />;
}

export const ProtectedRoute = ({ element, allowedRoles }) => {
  const { isLoading, isAuthenticated: authed } = useAuth();

  if (isLoading) {
    return null;
  }

  if (!authed) {
    return <Navigate to="/login" replace />;
  }

  const userRole = getUserRole();
  if (allowedRoles.includes(userRole)) {
    return element;
  }

  return <Navigate to="/admin-dashboard" replace state={{ accessDenied: true }} />;
};
